module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"allBuildings":"Gesamtportfolio ({n} Liegenschaften)","selectedBuildings":"Auswahl ({n} Liegenschaften)"}}')
  delete Component.options._Ctor
}
